

import { AgTableClient } from "app/shared/AgTable";
import PageHeader from "app/shared/PageHeader";
import React from "react";
const InvoiceCompliance = () => {
    return (
        <>
            <iframe
                       height="100%"
                       style={{ width: "100%" }}
                       scrolling="no"
                       title="Iframe"
                       id="dashboardFrame"
                       src={
                         //getFormattedURL(dashboardURLConfig[domain]?.[activeKey]) ||
                         "https://analytics.zoho.in/open-view/103074000045013978/60ffb5084968bbdc235e2bac29c68352"
                       }
                     ></iframe>
        </>
    )
};
export default InvoiceCompliance;


